import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api`);




// KPI Cards

export const getReportSummary = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/summary",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Status Chart

export const getTicketStatusReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/status",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Priority Chart

export const getPriorityReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/priority",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Category Chart

export const getCategoryReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/category",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Monthly Trend

export const getMonthlyTrend = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/trend",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Resolution Time

export const getResolutionTimeReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/resolution-time",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// SLA

export const getSLAReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/sla",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Recent Tickets

export const getRecentTickets = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/recent",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Projects Overview (status/type breakdown)

export const getProjectsOverview = async(departmentId = null, startDate = null, endDate = null)=>{

    const response = await API.get(
        "/reports/projects-overview",
        { params: { department_id: departmentId || undefined, start_date: startDate || undefined, end_date: endDate || undefined } }
    );

    return response.data;

};




// Capacity Overview (distribution + top allocated + bench)

export const getCapacityOverview = async(departmentId = null, startDate = null, endDate = null, minCapacity = null, maxCapacity = null)=>{

    const response = await API.get(
        "/reports/capacity-overview",
        { params: { department_id: departmentId || undefined, start_date: startDate || undefined, end_date: endDate || undefined, min_capacity: minCapacity ?? undefined, max_capacity: maxCapacity ?? undefined } }
    );

    return response.data;

};




// Board Overview (task status/type/priority + sprint velocity)

export const getBoardOverview = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/board-overview",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};


export const getExpiringAssignments = async(departmentId = null, startDate = null, endDate = null)=>{

    const response = await API.get(
        "/reports/expiring-assignments",
        { params: { department_id: departmentId || undefined, start_date: startDate || undefined, end_date: endDate || undefined } }
    );

    return response.data;

};


export const getWeeklyUtilization = async(departmentId = null, startDate = null, endDate = null)=>{

    const response = await API.get(
        "/reports/weekly-utilization",
        { params: { department_id: departmentId || undefined, start_date: startDate || undefined, end_date: endDate || undefined } }
    );

    return response.data;

};


export const uploadEmployeeNameMappingFile = async(file)=>{

    const formData = new FormData();
    formData.append("file", file);

    const response = await API.post(
        "/reports/employee-name-mappings/upload",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return response.data;

};


export const syncEmployeeNameMappings = async(filePath)=>{

    const response = await API.post(
        "/reports/employee-name-mappings/sync",
        { file_path: filePath }
    );

    return response.data;

};


export const getEmployeeNameMappings = async(search = "", onlyUnmatched = false)=>{

    const response = await API.get(
        "/reports/employee-name-mappings",
        {
            params: {
                search: search || undefined,
                only_unmatched: onlyUnmatched || undefined,
            }
        }
    );

    return response.data;

};


export default API;